/* JunLinLeather design language — shared runtime helpers.
   Loaded once by layout/theme.liquid on every page (vendor patch 14) before
   any component's own script, so a component may call JLL.* unguarded. */

window.JLL = window.JLL || {};

/* Tag the Dawn slide-in wrapper that contains an overlay component, so the
   jll-design.css entrance rules can neutralise its transform animation (an
   active transform animation is a containing block for position:fixed — the
   drawer-pinned-to-page-bottom bug) without depending on :has() support.
   Call from the component's connectedCallback; re-renders reconnect the
   element and re-tag the fresh wrapper automatically. */
window.JLL.tameEntrance = function (host) {
  var wrap = host.closest && host.closest('.scroll-trigger.animate--slide-in');
  if (wrap) wrap.classList.add('jll-fade-entrance');
};

/* Swipe a bottom drawer closed. The drawer follows the finger (never below
   rest) and lets go past a third of its height or on a flick (> 0.5 px/ms);
   anything short springs back. The listeners live on `zone`, a descendant of
   the component, so nothing is released by hand.

     zone   the drag strip (jll-drag)
     panel  the drawer to move and hand to onClose
     opts   canDrag  () => boolean   — mobile? open? asked before every drag
            ignore   selector        — descendants that are not drag handles
            onClose  ()              — called once, when the gesture dismisses

   No-ops without PointerEvent: the drawer keeps its X and its tap-outside. */
window.JLL.trackDrag = function (zone, panel, opts) {
  if (!zone || !panel || !window.PointerEvent) return;
  opts = opts || {};
  var canDrag = opts.canDrag || function () { return true; };
  var ignore = opts.ignore || '';
  var onClose = opts.onClose || function () {};
  var dragging = false, startY = 0, lastY = 0, lastT = 0, dy = 0, velocity = 0;

  zone.addEventListener('pointerdown', function (e) {
    if (!canDrag()) return;
    /* A right-click is not a drag. */
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    if (ignore && e.target.closest && e.target.closest(ignore)) return;
    dragging = true; dy = 0; velocity = 0;
    startY = lastY = e.clientY; lastT = e.timeStamp;
    panel.classList.add('is-dragging');
    zone.setPointerCapture(e.pointerId);
  });

  zone.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    dy = Math.max(0, e.clientY - startY);
    var dt = e.timeStamp - lastT;
    if (dt > 0) velocity = (e.clientY - lastY) / dt;
    lastY = e.clientY; lastT = e.timeStamp;
    panel.style.transform = 'translateY(' + dy + 'px)';
  });

  var up = function (e) {
    if (!dragging) return;
    dragging = false;
    panel.classList.remove('is-dragging');
    if (zone.hasPointerCapture(e.pointerId)) zone.releasePointerCapture(e.pointerId);
    var height = panel.offsetHeight || 1;
    if (dy > height * 0.33 || velocity > 0.5) onClose();
    else panel.style.transform = '';
  };
  zone.addEventListener('pointerup', up);
  zone.addEventListener('pointercancel', up);
};

/* Keep a bottom drawer above the on-screen keyboard, which shrinks only the
   VISUAL viewport (fact #20). While tracking, the drawer carries two custom
   properties that jll-design.css consumes:

     --jll-kb-inset  the keyboard overlap -> lifts the drawer's bottom edge
     --jll-vvh       the visual viewport height -> caps the drawer so its
                     pinned top strip stays on screen

   Returns the release function; a no-op without the VisualViewport API. */
window.JLL.trackKeyboard = function (panel) {
  var vv = window.visualViewport;
  if (!vv) return function () {};

  var update = function () {
    /* Pinch-zoom also shrinks the visual viewport (vv.scale > 1) with no
       keyboard anywhere — treating that as an inset would float the drawer
       to mid-screen, so a zoomed viewport reads as "no keyboard". */
    var zoomed = vv.scale > 1.01;
    var inset = zoomed ? 0 : Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    panel.style.setProperty('--jll-kb-inset', inset + 'px');
    panel.style.setProperty('--jll-vvh', Math.round(zoomed ? window.innerHeight : vv.height) + 'px');
  };

  update();
  vv.addEventListener('resize', update);
  vv.addEventListener('scroll', update);

  return function () {
    vv.removeEventListener('resize', update);
    vv.removeEventListener('scroll', update);
    panel.style.removeProperty('--jll-kb-inset');
    panel.style.removeProperty('--jll-vvh');
  };
};

/* Escape a string for innerHTML. */
window.JLL.escapeHtml = function (s) {
  return String(s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  });
};

/* Money in the presentment currency's own format. `sample` is 123456 minor
   units rendered by Liquid ("$1,234.56 USD", "1.234,56 €", "¥1,235"): the
   separators and decimals are read off it and the amount spliced back in its
   place, so symbol, code and their order are exactly Liquid's. Returns a
   formatter, minor units -> string. */
window.JLL.money = function (sample) {
  var cents2 = /1(\D?)234(\D)56/.exec(sample);
  var m = cents2 || /1(\D?)23[45](?!\d)/.exec(sample);
  if (!m) return function (cents) { return (cents / 100).toFixed(2); };
  var decimals = cents2 ? 2 : 0;
  return function (cents) {
    var parts = Math.abs(cents / 100).toFixed(decimals).split('.');
    var out = m[1] ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, m[1]) : parts[0];
    if (decimals) out += cents2[2] + parts[1];
    return sample.replace(m[0], (cents < 0 ? '-' : '') + out);
  };
};

/* A cart write, JSON in and out, that throws the cart's own sentence (`description`,
   `message` or `errors`, on a 200 or a 4xx alike). Every component's cart verbs go
   through here. Returns a promise of the parsed answer. */
window.JLL.cart = function (url, body) {
  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify(body),
  }).then(function (res) {
    return res.json().catch(function () { return {}; }).then(function (data) {
      if (!res.ok || data.status || data.errors) {
        throw new Error(data.description || data.message || data.errors || 'Something went wrong. Please try again.');
      }
      return data;
    });
  });
};

/* The popover/drawer lifecycle — one implementation for every component.

     host       the component: is-raised while open, Escape and Tab inside
     o.panel    the glass panel (jll-glass jll-drawer)
     o.scrim    the tap-outside layer; o.drag the strip
     o.close    selector: every control that closes (the X, a Done)
     o.ignore   selector: descendants of the strip that are not drag handles
     o.anchor   () => Element the desktop popover hangs from
     o.gap      popover distance from the anchor in px (12)
     o.flip     open above the anchor when there is no room below, turning
                o.arrow between jll-arrow--top and jll-arrow--bottom
     o.keyboard arm JLL.trackKeyboard while open (a drawer with inputs)
     o.trap     keep Tab inside the panel
     o.inside   (target) => bool: a click that is not "outside" (the host)
     o.onClose  (returnFocus) the component's own state, after every close

   Returns { open(), close(returnFocus), position(), isOpen, destroy() }.
   Every close — X, scrim, Escape, swipe, breakpoint, destroy — ends in the
   one hidden(); open() may re-enter while open and disarms before it
   re-arms. The 220 ms matches .jll-drawer's transition in jll-design.css. */
window.JLL.overlay = function (host, o) {
  var panel = o.panel, scrim = o.scrim;
  var mobile = window.matchMedia('(max-width: 749px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var api = { isOpen: false };
  var timer, untrack, resizeTimer;

  /* Drop any drag or slide-out in flight. */
  var settle = function () {
    clearTimeout(timer);
    panel.classList.remove('is-closing', 'is-dragging');
    panel.style.transform = '';
  };
  var hidden = function () {
    settle();
    panel.hidden = true;
    host.classList.remove('is-raised');
    if (untrack) { untrack(); untrack = null; }
  };

  api.position = function () {
    if (mobile.matches) { panel.style.left = ''; panel.style.top = ''; return; }
    /* A drawer dragged partway down must not carry that offset into the popover. */
    panel.style.transform = '';
    var anchor = o.anchor && o.anchor();
    if (!anchor) return;
    var h = host.getBoundingClientRect(), r = anchor.getBoundingClientRect();
    var pw = panel.offsetWidth, ph = panel.offsetHeight, gap = o.gap || 12;
    var left = Math.max(0, Math.min(r.left - h.left + r.width / 2 - pw / 2, h.width - pw));
    var below = !o.flip || window.innerHeight - r.bottom >= ph + gap * 2 || r.top < ph + gap * 2;
    panel.style.left = Math.round(left) + 'px';
    panel.style.top = Math.round(below ? r.bottom - h.top + gap : r.top - h.top - ph - gap) + 'px';
    panel.style.setProperty('--jll-arrow-x', Math.round(r.left - h.left + r.width / 2 - left) + 'px');
    if (o.arrow) {
      o.arrow.classList.toggle('jll-arrow--top', below);
      o.arrow.classList.toggle('jll-arrow--bottom', !below);
    }
  };

  api.open = function () {
    settle();
    panel.hidden = false;
    if (scrim) scrim.hidden = !mobile.matches;
    host.classList.add('is-raised');
    if (untrack) untrack();
    untrack = o.keyboard ? window.JLL.trackKeyboard(panel) : null;
    api.isOpen = true;
    api.position();
  };

  api.close = function (returnFocus) {
    if (!api.isOpen) return;
    api.isOpen = false;
    if (scrim) scrim.hidden = true;
    clearTimeout(timer);
    if (mobile.matches && !reduced.matches) {
      /* Slide out, then hide: [hidden] would cut the animation dead. */
      panel.classList.add('is-closing');
      panel.style.transform = 'translateY(100%)';
      timer = setTimeout(hidden, 220);
    } else {
      hidden();
    }
    if (o.onClose) o.onClose(!!returnFocus);
  };

  var onDoc = function (e) {
    if (!api.isOpen || panel.contains(e.target)) return;
    if (o.inside ? o.inside(e.target) : host.contains(e.target)) return;
    api.close(false);
  };
  var onResize = function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { if (api.isOpen) api.position(); }, 100);
  };
  /* Crossing the breakpoint swaps popover and drawer in CSS; the scrim and the
     coordinates follow, and a close that was still sliding out is finished. */
  var onBreakpoint = function () {
    settle();
    if (!api.isOpen) { if (!panel.hidden) hidden(); return; }
    if (scrim) scrim.hidden = !mobile.matches;
    api.position();
  };
  var onKey = function (e) {
    if (!api.isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); api.close(true); return; }
    if (e.key !== 'Tab' || !o.trap || !panel.contains(document.activeElement)) return;
    var f = panel.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]');
    if (!f.length) return;
    var edge = e.shiftKey ? f[0] : f[f.length - 1];
    if (document.activeElement === edge) {
      e.preventDefault();
      (e.shiftKey ? f[f.length - 1] : f[0]).focus();
    }
  };
  document.addEventListener('click', onDoc);
  window.addEventListener('resize', onResize);
  mobile.addEventListener('change', onBreakpoint);
  host.addEventListener('keydown', onKey);
  if (scrim) scrim.addEventListener('click', function () { api.close(false); });
  if (o.close) host.querySelectorAll(o.close).forEach(function (b) { b.addEventListener('click', function () { api.close(true); }); });
  if (o.drag) {
    window.JLL.trackDrag(o.drag, panel, {
      canDrag: function () { return mobile.matches && api.isOpen; },
      ignore: o.ignore,
      onClose: function () { api.close(false); },
    });
  }

  /* Editor re-renders replace the element with the panel open. */
  api.destroy = function () {
    document.removeEventListener('click', onDoc);
    window.removeEventListener('resize', onResize);
    mobile.removeEventListener('change', onBreakpoint);
    host.removeEventListener('keydown', onKey);
    hidden();
  };
  return api;
};
